var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"version"},[_vm._v("v"+_vm._s(_vm.APP_VERSION))]),_c('div',{staticClass:"copyright"},[_vm._v(" © "+_vm._s(_vm.footerYear)+", developed by "),_c('a',{attrs:{"href":_vm.footerWebsite,"target":"_blank"}},[_vm._v(_vm._s(_vm.footerCompany))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }